import { useLazyQuery } from '@apollo/client';
import { GET_TRAIT_ASSESSMENT_PROGRESS, GET_ALL_TRAIT_ASSESSMENT_PROGRESS } from '../../apollo/queries/forcedChoice';

const useFetchTraitAssessmentProgress = () => {
  const [fetchProgress, traitProgressStatus] = useLazyQuery(GET_TRAIT_ASSESSMENT_PROGRESS);
  const [fetchAllTraitProgress, allProgressStatus] = useLazyQuery(GET_ALL_TRAIT_ASSESSMENT_PROGRESS);

  return {
    fetchProgress,
    fetchAllTraitProgress,
    ...traitProgressStatus,
    ...allProgressStatus
  };
};

export default useFetchTraitAssessmentProgress;